import { Component, Input, OnInit, inject } from '@angular/core';
import { RoutingService } from '../../service/common/routing/routing.service';
import { Datenabfrage } from '../../domain/model/datenabfrage/datenabfrage';

@Component({
    selector: 'tnb-notify-datenabfrage',
    templateUrl: './notify-datenabfrage.component.html',
    styleUrls: [
        './notify-datenabfrage.component.scss',
    ],
    standalone: false,
})
export class NotifyDatenabfrageComponent implements OnInit {
    routingService = inject(RoutingService);

    @Input() public aktiveDatenAbfrage: Datenabfrage;
    public showPanel = false;

    ngOnInit(): void {
        if (this.aktiveDatenAbfrage != null) {
            this.showPanel = true;
        }
    }


}
